import React from 'react'

import { BackendError } from '../domain/BackendError'
import ErrorCover from './errorCover'
import LoadingCover from './loadingCover'

interface Props {
    loading: boolean
    error: BackendError | null
    className: string
    noPadding: boolean
    style?: React.CSSProperties
    children?: React.ReactNode
}
class BoxBody extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        error: null,
        className: '',
        children: null,
        noPadding: false,
    }

    public render() {
        let className = 'box-body ' + this.props.className
        // no idea what should actually be passed, but passing all props is a bad idea,
        // so I am trying to pick the important parts.
        /* eslint-disable */
        const childProps = {
            style: this.props.style,
        }
        /* eslint-enable */

        if (this.props.noPadding) {
            className += ' no-padding'
        }

        return (
            <div className={className} {...childProps}>
                {this.props.error ? <ErrorCover message={this.props.error.msg} /> : null}
                {!this.props.error && this.props.loading ? <LoadingCover /> : null}
                {this.props.children}
            </div>
        )
    }
}

export default BoxBody
